<template>
  <div class="recharge-page">
    <div class="page-title flex-center-start">
      <img :src="backUrl" alt="" @click="back" />
      {{ $t("assest.label10") }}
    </div>

    <div class="recharge-main">
      <div class="page-form">
        <div class="form-item">
          <div class="label">{{ i18n.t("exchange.label1") }}</div>
          <div class="input">
            <a-select
              v-model="form.fromCurrency"
              @change="chooseFromCurrency"
              dropdownClassName="full-select"
              class="hide-border"
              :placeholder="$t('qing-xuan-ze-0')"
              showSearch
              :filterOption="filterCurrency"
            >
              <img :src="downUrl" slot="suffixIcon" class="suffix-icon" />
              <a-select-option
                v-for="(option, index) in currencyList"
                :key="index"
                :value="option.Currency.ShortName + '|' + option.Currency.ID"
              >
                {{ option.Currency.ShortName }} ({{
                  i18n.t("exchange.label6")
                }}:
                {{
                  resetMoney(
                    parseFloat(option.CapitalUse || 0) +
                      parseFloat(option.CapitalFree || 0)
                  )
                }})
              </a-select-option>
            </a-select>
          </div>
        </div>

        <div class="form-item">
          <div class="label">{{ i18n.t("exchange.label3") }}</div>
          <div class="input">
            <input
              type="text"
              v-model="form.fromAmount"
              :placeholder="i18n.t('exchange.labelPlaceholder3')"
              @input="calculateToAmount"
            />
            <div class="adot long" @click="setAll">
              {{ i18n.t("exchange.label5") }}
            </div>
          </div>
          <div class="desc-line flex-center-start">
            <div>{{ i18n.t("exchange.label6") }}：</div>
            <div class="count">
              {{ resetMoney(userBalance) }} {{ form.fromCurrency }}
            </div>
          </div>
        </div>

        <div class="img-line flex-center" @click="switchCurrency">
          <img :src="transferUrl" alt="" />
        </div>

        <div class="form-item">
          <div class="label">{{ i18n.t("exchange.label2") }}</div>
          <div class="input">
            <a-select
              v-model="form.toCurrency"
              @change="chooseToCurrency"
              dropdownClassName="full-select"
              class="hide-border"
              :placeholder="$t('qing-xuan-ze-1')"
              showSearch
              :filterOption="filterCurrency"
            >
              <img :src="downUrl" slot="suffixIcon" class="suffix-icon" />
              <a-select-option
                v-for="(option, index) in currencyList"
                :key="index"
                :value="option.Currency.ShortName + '|' + option.Currency.ID"
                :disabled="option.Currency.ID == form.fromCurrencyId"
              >
                {{ option.Currency.ShortName }}
              </a-select-option>
            </a-select>
          </div>
        </div>

        <div class="form-item">
          <div class="label">{{ i18n.t("exchange.label4") }}</div>
          <div class="input disabled">
            <input
              type="text"
              v-model="form.toAmount"
              :placeholder="i18n.t('exchange.labelPlaceholder2')"
              readonly
            />
          </div>
          <div class="desc-line flex-center-start">
            <div>{{ i18n.t("exchange.label7") }}：</div>
            <div class="count">
              1 {{ form.fromCurrency }} ≈ {{ exchangeRate }}
              {{ form.toCurrency }}
            </div>
          </div>
        </div>

        <div class="btn">
          <Button @click="submit">{{ i18n.t("exchange.btn") }}</Button>
        </div>
      </div>
    </div>

    <div class="space-line"></div>

    <div class="page-title">{{ $t("quan-bu-shan-dui-ji-lu") }}</div>

    <div class="list-table clear-bg">
      <div class="th-line flex-center-between">
        <div class="th flex-2">{{ $t("exchange.label8") }}</div>
        <div class="th flex-2">{{ $t("chart_page.time") }}</div>
        <div class="th flex-2">{{ $t("exchange.label1") }}</div>
        <div class="th flex-2">{{ $t("dao") }}</div>
        <div class="th flex-2">{{ $t("exchange.label9") }}</div>
        <div class="th action">{{ $t("finance.label12") }}</div>
      </div>
      <div class="tbody">
        <div
          class="td-line flex-center-between"
          v-for="(item, i) in logList"
          :key="i"
        >
          <div class="td flex-2 flex-center-start">
            <img :src="'/upload/' + item.FromCurrency.Logo" alt="" />
            <span
              >{{ item.FromCurrency.ShortName }} →
              {{ item.ToCurrency.ShortName }}</span
            >
          </div>
          <div class="td flex-2">{{ formatTime(item.CreatedAt) }}</div>
          <div class="td flex-2">
            {{ parseFloat(item.FromAmount).toFixed(4) }}
            {{ item.FromCurrency.ShortName }}
          </div>
          <div class="td flex-2">
            {{ parseFloat(item.ToAmount).toFixed(4) }}
            {{ item.ToCurrency.ShortName }}
          </div>
          <div class="td flex-2">{{ parseFloat(item.Rate).toFixed(6) }}</div>
          <div class="td action flex-center">
            <span class="point"></span>
            {{ i18n.t("exchange.success") }}
          </div>
        </div>
      </div>
    </div>

    <pageBar :total="page.total" @changePage="changePage"></pageBar>
  </div>
</template>

<script>
import { Popup, Button } from "vant";
import { wallet, exchange, exchangeLog } from "@/api/assest";
import { getExchangeRate } from "@/api/index";
import pageBar from "@/components/pageBar";

export default {
  components: {
    Popup,
    Button,
    pageBar,
  },
  data() {
    return {
      form: {
        fromCurrency: "",
        toCurrency: "",
        fromCurrencyId: 0,
        toCurrencyId: 0,
        fromAmount: "",
        toAmount: "",
      },
      userBalance: 0,
      exchangeRate: "0.00",
      backUrl: require("../../assets/imgs/icon-back.png"),
      transferUrl: require("../../assets/imgs/icon-transfer2.png"),
      downUrl: require("../../assets/imgs/icon-arrow-down2.png"),
      currencyList: [],
      page: {
        page: 1,
        limit: 10,
        total: 1,
      },
      logList: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getCurrencyList();
      this.getExchangeLog();
    },

    back() {
      this.$router.go(-1);
    },

    resetMoney(val) {
      return parseFloat(val || 0).toFixed(4);
    },

    // 币种搜索过滤
    filterCurrency(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    // 获取币种列表
    getCurrencyList() {
      // 获取所有钱包数据，不再过滤余额
      wallet({
        current: 1,
        pageSize: 200,
      })
        .then((res) => {
          let items = res.data.Items || [];
          // 显示所有币种，不再过滤余额
          this.currencyList = items.filter((item) => {
            return item.Currency && item.Currency.ShortName;
          });

          // 按余额从高到低排序，余额相同时按币种名称排序
          this.currencyList.sort((a, b) => {
            const balanceA =
              parseFloat(a.CapitalUse || 0) + parseFloat(a.CapitalFree || 0);
            const balanceB =
              parseFloat(b.CapitalUse || 0) + parseFloat(b.CapitalFree || 0);

            // 先按余额排序（从高到低）
            if (balanceB !== balanceA) {
              return balanceB - balanceA;
            }

            // 余额相同时按币种名称排序
            return a.Currency.ShortName.localeCompare(b.Currency.ShortName);
          });

          // 默认选择第一个币种作为兑换币种
          if (this.currencyList.length > 0) {
            const firstCurrency = this.currencyList[0].Currency;
            this.form.fromCurrency = firstCurrency.ShortName;
            this.form.fromCurrencyId = firstCurrency.ID;
            console.log(
              "默认选择源币种:",
              this.form.fromCurrency,
              "ID:",
              this.form.fromCurrencyId
            );
            this.getUserBalance();

            // 默认选择USDT作为目标币种（如果存在且不是源币种）
            const usdtIndex = this.currencyList.findIndex(
              (item) =>
                item.Currency.ShortName.toUpperCase() === "USDT" &&
                item.Currency.ID !== this.form.fromCurrencyId
            );
            if (usdtIndex > -1) {
              const usdtCurrency = this.currencyList[usdtIndex].Currency;
              this.form.toCurrency = usdtCurrency.ShortName;
              this.form.toCurrencyId = usdtCurrency.ID;
            } else if (this.currencyList.length > 1) {
              // 如果没有USDT或USDT是源币种，选择第二个币种
              const secondCurrency = this.currencyList[1].Currency;
              this.form.toCurrency = secondCurrency.ShortName;
              this.form.toCurrencyId = secondCurrency.ID;
            }
            console.log(
              "默认选择目标币种:",
              this.form.toCurrency,
              "ID:",
              this.form.toCurrencyId
            );

            // 获取初始汇率
            this.getRate();
          }
        })
        .catch((err) => {
          console.error("获取币种列表失败:", err);
          this.$toast.fail("获取币种列表失败");
        });
    },

    getUserBalance() {
      if (!this.form.fromCurrency) return;

      const currentWallet = this.currencyList.find(
        (item) => item.Currency.ShortName === this.form.fromCurrency
      );

      if (currentWallet) {
        // 计算资金账户的总余额（可用+冻结）
        this.userBalance =
          parseFloat(currentWallet.CapitalUse || 0) +
          parseFloat(currentWallet.CapitalFree || 0);
      } else {
        this.userBalance = 0;
      }
    },

    getRate() {
      if (
        this.form.fromCurrencyId &&
        this.form.toCurrencyId &&
        this.form.fromCurrencyId !== this.form.toCurrencyId
      ) {
        // 检查是否是 USDT <-> USDC 兑换，使用固定汇率 1:1
        const fromCurrencyUpper = this.form.fromCurrency.toUpperCase();
        const toCurrencyUpper = this.form.toCurrency.toUpperCase();

        if (
          (fromCurrencyUpper === "USDT" && toCurrencyUpper === "USDC") ||
          (fromCurrencyUpper === "USDC" && toCurrencyUpper === "USDT")
        ) {
          // USDT <-> USDC 固定汇率 1:1
          this.exchangeRate = "1.00000000";
          console.log(
            `USDT <-> USDC 固定汇率: 1 ${this.form.fromCurrency} = 1 ${this.form.toCurrency}`
          );
          // 重新计算兑换数量
          this.calculateToAmount();
          return;
        }

        // 获取所有交易数据
        getExchangeRate({})
          .then((res) => {
            const tradesList = res.data || [];
            console.log("获取到的交易数据:", tradesList);

            let fromPrice = 1; // 源币种的USDT价格
            let toPrice = 1; // 目标币种的USDT价格

            // 获取USDT的币种ID（假设USDT的ID是固定的，或者从币种列表中查找）
            const usdtCurrency = this.currencyList.find(
              (item) => item.Currency.ShortName.toUpperCase() === "USDT"
            );
            const usdtId = usdtCurrency ? usdtCurrency.Currency.ID : 3; // 默认USDT ID为3

            // 获取源币种的USDT价格
            if (this.form.fromCurrencyId === usdtId) {
              fromPrice = 1;
            } else {
              const fromTrade = tradesList.find(
                (trade) => trade.CurrencyId === this.form.fromCurrencyId
              );
              if (fromTrade && fromTrade.Price) {
                fromPrice = parseFloat(fromTrade.Price);
                console.log(
                  `${this.form.fromCurrency} (ID:${this.form.fromCurrencyId}) 价格:`,
                  fromPrice
                );
              } else {
                console.error(
                  `未找到币种ID ${this.form.fromCurrencyId} (${this.form.fromCurrency}) 的价格数据`
                );
                this.exchangeRate = "0.00000000";
                return;
              }
            }

            // 获取目标币种的USDT价格
            if (this.form.toCurrencyId === usdtId) {
              toPrice = 1;
            } else {
              const toTrade = tradesList.find(
                (trade) => trade.CurrencyId === this.form.toCurrencyId
              );
              if (toTrade && toTrade.Price) {
                toPrice = parseFloat(toTrade.Price);
                console.log(
                  `${this.form.toCurrency} (ID:${this.form.toCurrencyId}) 价格:`,
                  toPrice
                );
              } else {
                console.error(
                  `未找到币种ID ${this.form.toCurrencyId} (${this.form.toCurrency}) 的价格数据`
                );
                this.exchangeRate = "0.00000000";
                return;
              }
            }

            // 计算汇率：1个源币种能兑换多少个目标币种
            const rate = fromPrice / toPrice;
            this.exchangeRate = rate.toFixed(8);

            console.log(`汇率计算: ${fromPrice} / ${toPrice} = ${rate}`);
            console.log(
              `最终汇率: 1 ${this.form.fromCurrency} = ${this.exchangeRate} ${this.form.toCurrency}`
            );

            // 重新计算兑换数量
            this.calculateToAmount();
          })
          .catch((err) => {
            console.error("获取交易价格失败:", err);
            this.exchangeRate = "0.00000000";
          });
      } else {
        this.exchangeRate = "0.00000000";
      }
    },

    chooseFromCurrency(value) {
      console.log("选择源币种:", value);
      const [currencyName, currencyId] = value.split("|");
      this.form.fromCurrency = currencyName;
      this.form.fromCurrencyId = parseInt(currencyId);
      console.log("源币种ID:", this.form.fromCurrencyId);
      this.getUserBalance();

      // 如果还没有选择目标币种，或者目标币种与源币种相同，才清空输入
      if (
        !this.form.toCurrencyId ||
        this.form.fromCurrencyId === this.form.toCurrencyId
      ) {
        this.form.fromAmount = "";
        this.form.toAmount = "";
      }

      this.getRate();
    },

    chooseToCurrency(value) {
      console.log("选择目标币种:", value);
      const [currencyName, currencyId] = value.split("|");
      this.form.toCurrency = currencyName;
      this.form.toCurrencyId = parseInt(currencyId);
      console.log("目标币种ID:", this.form.toCurrencyId);
      // 不清空输入金额，保持用户体验
      // this.form.fromAmount = ''
      // this.form.toAmount = ''
      this.getRate();
    },

    calculateToAmount() {
      if (
        this.form.fromAmount &&
        this.exchangeRate &&
        parseFloat(this.exchangeRate) > 0
      ) {
        const fromAmount = parseFloat(this.form.fromAmount);
        const rate = parseFloat(this.exchangeRate);
        const toAmount = fromAmount * rate;
        this.form.toAmount = toAmount.toFixed(8);
        console.log(`兑换计算: ${fromAmount} × ${rate} = ${toAmount}`);
      } else {
        this.form.toAmount = "";
      }
    },

    switchCurrency() {
      if (!this.form.fromCurrencyId || !this.form.toCurrencyId) return;

      console.log(
        "切换币种前:",
        this.form.fromCurrency,
        "(ID:",
        this.form.fromCurrencyId,
        ") ->",
        this.form.toCurrency,
        "(ID:",
        this.form.toCurrencyId,
        ")"
      );

      // 交换币种名称和ID
      const tempName = this.form.fromCurrency;
      const tempId = this.form.fromCurrencyId;
      this.form.fromCurrency = this.form.toCurrency;
      this.form.fromCurrencyId = this.form.toCurrencyId;
      this.form.toCurrency = tempName;
      this.form.toCurrencyId = tempId;

      console.log(
        "切换币种后:",
        this.form.fromCurrency,
        "(ID:",
        this.form.fromCurrencyId,
        ") ->",
        this.form.toCurrency,
        "(ID:",
        this.form.toCurrencyId,
        ")"
      );

      this.form.fromAmount = "";
      this.form.toAmount = "";
      this.getUserBalance();
      this.getRate();
    },

    setAll() {
      this.form.fromAmount = this.userBalance.toString();
      this.calculateToAmount();
    },

    submit() {
      if (!this.form.fromAmount || parseFloat(this.form.fromAmount) <= 0) {
        this.$toast.fail(this.i18n.t("exchange.error1"));
        return;
      }

      if (parseFloat(this.form.fromAmount) > parseFloat(this.userBalance)) {
        this.$toast.fail(this.i18n.t("exchange.error2"));
        return;
      }

      if (this.form.fromCurrencyId === this.form.toCurrencyId) {
        this.$toast.fail(this.i18n.t("exchange.error3"));
        return;
      }

      exchange({
        fromCurrencyId: this.form.fromCurrencyId,
        toCurrencyId: this.form.toCurrencyId,
        fromAmount: this.form.fromAmount,
        // 移除toAmount和rate，由服务端计算
        // toAmount: this.form.toAmount,
        // rate: this.exchangeRate
      })
        .then((res) => {
          // 检查响应的code字段，0表示成功，其他表示失败
          if (res.code === 0) {
            this.$toast.success(this.i18n.t("exchange.success_msg"));
            this.form.fromAmount = "";
            this.form.toAmount = "";
            this.getCurrencyList(); // 重新获取币种列表以更新余额
            this.getExchangeLog();
          } else {
            // 显示错误消息
            this.$toast.fail(res.msg || this.i18n.t("exchange.error4"));
          }
        })
        .catch((err) => {
          this.$toast.fail(err.message || this.i18n.t("exchange.error4"));
        });
    },

    getExchangeLog() {
      exchangeLog({
        page: this.page.page,
        limit: this.page.limit,
      })
        .then((res) => {
          this.logList = res.data.Items || [];
          this.page.total = res.data.Count || 0;
        })
        .catch(() => {
          this.logList = [];
        });
    },

    changePage(page) {
      this.page.page = page;
      this.getExchangeLog();
    },

    formatTime(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString();
    },
  },
};
</script>

<style scoped>
.disabled input {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.desc-line {
  margin-top: 8px;
  font-size: 12px;
  color: #999;
}

.img-line {
  margin: 20px 0;
  cursor: pointer;
}

.img-line img {
  transform: rotate(90deg);
}
</style>
